<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view :key="$route.fullPath" />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
    <cookie-law></cookie-law>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import CookieLaw from "vue-cookie-law";
import { mapActions } from "vuex";

export default {
  methods: mapActions(["fetchRanges"]),
  components: {
    FadeTransition,
    CookieLaw
  },
  mounted() {
    this.fetchRanges();
  }
};
</script>
